import React from "react";
import { Modal, Input, Typography, Divider } from "antd";

const { Text, Paragraph } = Typography;

interface ConfirmActionModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: () => Promise<void>;
  confirmText: string;
  setConfirmText: (text: string) => void;
  requiredConfirmText: string;
  title: string;
  okText: string;
  warningItems: string[];
  loading?: boolean;
  icon?: React.ReactNode;
}

const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({
  visible,
  onCancel,
  onOk,
  confirmText,
  setConfirmText,
  requiredConfirmText,
  title,
  okText,
  warningItems,
  loading = false,
  icon = (
    <i
      className="ri-alert-line"
      style={{ fontSize: 22, color: "#ff4d4f", marginRight: 12 }}
    />
  ),
}) => {
  return (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center" }}>
          {icon}
          <span style={{ fontSize: 18, fontWeight: 500 }}>{title}</span>
        </div>
      }
      open={visible}
      onCancel={onCancel}
      okText={okText}
      cancelText="取消"
      okButtonProps={{
        danger: true,
        disabled: confirmText !== requiredConfirmText,
        loading: loading,
      }}
      onOk={onOk}
      width={520}
      centered
      className="confirm-action-modal"
    >
      <div style={{ marginBottom: 24 }}>
        <Paragraph style={{ fontSize: 15, marginBottom: 16, fontWeight: 500 }}>
          请注意以下事项：
        </Paragraph>

        <div
          style={{
            background: "#fff2f0",
            border: "1px solid #ffccc7",
            borderRadius: "8px",
            padding: "12px 16px",
            marginBottom: 20,
          }}
        >
          <ul
            style={{
              paddingLeft: 20,
              marginBottom: 0,
              color: "#cf1322",
            }}
          >
            {warningItems.map((item, index) => (
              <li
                key={index}
                style={{
                  marginBottom: index === warningItems.length - 1 ? 0 : 8,
                }}
              >
                {item}
              </li>
            ))}
          </ul>
        </div>

        <Divider plain style={{ margin: "20px 0" }}>
          <Text type="secondary">确认操作</Text>
        </Divider>

        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <Paragraph>如果您确定要继续，请在下方输入：</Paragraph>
          <Text
            strong
            style={{
              color: "#ff4d4f",
              fontSize: 16,
              padding: "6px 12px",
              background: "#fff2f0",
              border: "1px dashed #ffccc7",
              borderRadius: "4px",
              display: "inline-block",
            }}
          >
            {requiredConfirmText}
          </Text>
        </div>
      </div>

      <Input
        value={confirmText}
        onChange={(e) => setConfirmText(e.target.value)}
        placeholder="请输入确认文本"
        size="large"
        status={
          confirmText && confirmText !== requiredConfirmText ? "error" : ""
        }
        prefix={<i className="ri-key-2-line" style={{ color: "#bfbfbf" }} />}
      />

      {confirmText && confirmText !== requiredConfirmText && (
        <Text type="danger" style={{ display: "block", marginTop: 8 }}>
          输入的文本不匹配，请检查后重试
        </Text>
      )}
    </Modal>
  );
};

export default ConfirmActionModal;
